import { combine, fromEvent } from '@jack-henry/frontend-utils/observable';
import { LoggingService } from '@treasury/core/logging';
import { WindowService } from '@treasury/utils';

export abstract class StatusService {
    constructor(
        protected readonly window: WindowService,
        protected readonly logger: LoggingService
    ) {}

    public readonly online$ = this.createOnlineObservable();

    protected abstract getApiStatus(): Promise<{ success: boolean }>;

    private createOnlineObservable() {
        const online$ = fromEvent(this.window, 'online').pipe(() => true);
        const offline$ = fromEvent(this.window, 'offline').pipe(() => false);

        return combine(online$, offline$).pipe(async isOnline => {
            if (!isOnline) {
                return false;
            }

            // verify connectivity to the API even after an online event
            try {
                const { success } = await this.getApiStatus();
                return success;
            } catch {
                this.logger.logWarning('Could not communicate with the TM API.');
                return false;
            }
        });
    }
}
